import { v4 as uuidv4 } from 'uuid';

export const getAnonymousUuid = (): string => {
  try {
    if (typeof localStorage !== 'undefined') {
      let anonymousUuid = localStorage.getItem('anonymousUuid');

      if (!anonymousUuid) {
        anonymousUuid = uuidv4();
        localStorage.setItem('anonymousUuid', anonymousUuid);
      }

      return anonymousUuid;
    }
  } catch (error) {
    console.warn(
      'Failed to access localStorage, generating temporary UUID',
      error
    );
  }

  return uuidv4();
};
